/** Раздел «Шаблоны» — ровно то, что отдают `GET /api/chats/templates/library` и `…/phrases`. */
import { apiFetch, query } from "@/lib/api";

export type LibraryTemplate = {
  id: number;
  title: string;
  text: string;
  /** Сколько раз такой ответ отправляли; null — в переписке не встречался. */
  sent: number | null;
};
export type Library = {
  /** Чьи личные показаны; null — общие. */
  owner: number | null;
  /** У кого есть личные шаблоны. */
  owners: { id: number; name: string; templates: number }[];
  categories: { id: number; name: string; templates: LibraryTemplate[] }[];
  /** Когда пересобран кэш отправок, MSK; null — ещё не собирали. */
  built: string | null;
};

export type Phrase = {
  id: number;
  /** Самое частое написание; имена заменены на `{имя}`. */
  text: string;
  /** Отправок под отбор и всего. */
  count: number;
  total: number;
  variants: number;
  first: string;
  last: string;
  /** Чат последней отправки. */
  chat_id: number;
  /** Кто отправлял (без отбора по сотруднику); `name` пусто — автор неизвестен. */
  authors: { name: string; count: number }[];
  channels: { channel: string; count: number }[];
  /** Шаблоны с тем же текстом: `owner` null — общий, иначе личный сотрудника. */
  templates: { id: number; title: string; category: string; owner: number | null; owner_name: string }[];
};
export type Phrases = {
  phrases: Phrase[];
  total: { phrases: number; sent: number };
  authors: { name: string; count: number }[];
  channels: { channel: string; count: number }[];
  built: string | null;
};

export type PhraseParams = {
  /** Имя сотрудника; `-` — автор неизвестен; пусто — все. */
  author: string;
  channel: string;
  /** За сколько последних дней; 0 — всё время. */
  days: number;
  short: boolean;
  auto: boolean;
  q: string;
};

const BASE = "/api/chats/templates";

export const loadLibrary = (owner: number | null) => apiFetch<Library>(`${BASE}/library${query({ owner })}`);
export const loadPhrases = (p: PhraseParams) => apiFetch<Phrases>(`${BASE}/phrases${query({ ...p, days: p.days || null })}`);
